import * as Yup from 'yup';

const schema = Yup.object().shape({
    plan: Yup.string().notOneOf(['select', 'Choose value']).required('Required'),
    cloud: Yup.string().notOneOf(['select', 'Choose value']).required('Required'),
});

export default schema;
